export default "__VITE_ASSET__CtWccuF2__"